/**
 * 公開状態（visibility）に対するラベル定義
 */

type VisibilityValue = 'public' | 'private' | 'hospital_only';

const VISIBILITY_BADGE_LABELS: Record<VisibilityValue, string> = {
  public: '外部公開中',
  hospital_only: '院内公開中',
  private: '非公開',
};

const VISIBILITY_CHANGE_MESSAGES: Record<VisibilityValue, string> = {
  public: '動画を外部公開しました',
  hospital_only: '動画を院内公開しました',
  private: '動画を非公開にしました',
};

const VISIBILITY_MENU_OPTIONS: Record<VisibilityValue, Array<{ visibility: VisibilityValue; label: string }>> = {
  private: [
    { visibility: 'hospital_only', label: '院内公開にする' },
    { visibility: 'public', label: '外部公開にする' },
  ],
  hospital_only: [
    { visibility: 'private', label: '非公開にする' },
    { visibility: 'public', label: '外部公開にする' },
  ],
  public: [
    { visibility: 'private', label: '非公開にする' },
    { visibility: 'hospital_only', label: '院内公開にする' },
  ],
};

const VISIBILITY_NEXT_CYCLE: Record<VisibilityValue, VisibilityValue> = {
  private: 'hospital_only',
  hospital_only: 'public',
  public: 'private',
};

export {
  VISIBILITY_BADGE_LABELS,
  VISIBILITY_CHANGE_MESSAGES,
  VISIBILITY_MENU_OPTIONS,
  VISIBILITY_NEXT_CYCLE,
};

export type { VisibilityValue };
